import React, { useMemo } from "react";
import styled from "styled-components";
import PathwayTextInputGroup from "../_UI/Components/Inputs/PathwayTextInputGroup";
import { PathwayTooltip } from "../_UI/Components/PathwayTooltip";
import { getCountryList } from "../_services/phone-utils";
import PathwaySelectMenu from "../_UI/Components/Inputs/PathwaySelectMenu";

const PhoneNumberInput = ({
    phoneCountryCode,
    phoneLocal,
    onCountryCodeChange,
    onPhoneLocalChange,
    disabled = false,
    required = false,
    error = "",
    label = "Telefonnummer",
    tooltip = "",
    placeholder = "xxx xxx xxxx",
    countryCodeDataCy = "phone-country-code-select",
    phoneInputDataCy = "phone-number-input",
}) => {
    const countryList = useMemo(() => getCountryList(), []);

    const handleCountryCodeChange = (ev) => {
        onCountryCodeChange(ev.target.value);
    };

    const handlePhoneLocalChange = (ev) => {
        // Only allow digits
        const value = ev.target.value.replace(/\D/g, "");
        onPhoneLocalChange(value);
    };

    return (
        <PhoneFieldWrapper>
            <LabelRow>
                <Label>
                    {label}
                    {required && <RequiredMark> *</RequiredMark>}
                </Label>
                {tooltip && (
                    <PathwayTooltip id={`${phoneInputDataCy}-tooltip`} iconSize="var(--iconSize-xs)">
                        {tooltip}
                    </PathwayTooltip>
                )}
            </LabelRow>
            <PhoneRow>
                <PathwaySelectMenu
                    name="phoneCountryCode"
                    ariaLabel="Landesvorwahl"
                    value={phoneCountryCode}
                    onChange={handleCountryCodeChange}
                    dataCy={countryCodeDataCy}
                    disabled={disabled}
                >
                    {countryList.map((c) => (
                        <option key={`${c.iso}-${c.code}`} value={c.code}>
                            {c.code} {c.name}
                        </option>
                    ))}
                </PathwaySelectMenu>
                <PathwayTextInputGroup
                    name="phoneNumberLocal"
                    value={phoneLocal}
                    submitted={false}
                    handleChange={handlePhoneLocalChange}
                    dataCy={phoneInputDataCy}
                    placeHolder={placeholder}
                    disabled={disabled}
                />
            </PhoneRow>
            {error && <PhoneError data-cy="phone-number-error">{error}</PhoneError>}
        </PhoneFieldWrapper>
    );
};

export default PhoneNumberInput;

const PhoneFieldWrapper = styled.div`
    position: relative;
    display: grid;
    row-gap: var(--gap-s);
`;

const LabelRow = styled.div`
    display: flex;
    align-items: center;
    gap: var(--gap-s);
`;

const Label = styled.label`
    font-weight: 600;
    color: var(--text-body);
`;

const PhoneRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: var(--gap-s);
    align-items: center;
`;


const RequiredMark = styled.span`
    color: var(--pw-danger);
`;

const PhoneError = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: 0;
    padding-top: var(--gap-s);
    color: var(--pw-danger);
    font-size: var(--pw-text-sm);
`;
